import { NgRedux, select } from '@angular-redux/store';
import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from '../../authentication/authentication.service';
import { FinegrainRolesService } from '../../common/services/finegrain-roles/finegrain-roles.service';
import { AdminDispatcher } from '../../store/admin-store/admin-dispatcher';
import { ApiResponseActions } from '../../store/api-response/api-response-actions';
import { ApiResponseState } from '../../store/api-response/api-response-state.model';
import { AuthDispatcher } from '../../store/auth/auth-dispatcher';
import { Auth } from '../../store/auth/auth-state.model';
import { SelectedVehicleState } from '../../store/selected-vehicle-store/selected-vehicle-state.model';
import { AppState } from '../../store/state.model';
import { OrchestrationService } from '../services/orchestration-service/orchestration.service';
import { SidenavService } from '../services/sidenav.service';
import { MatSidenavContainer, MatSidenav as MatSidenav_1 } from '@angular/material/sidenav';
import { NgIf } from '@angular/common';
import { TssComponent } from '../tss/tss.component';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { MatButton } from '@angular/material/button';
import { SearchResultsComponent } from '../search-results/search-results.component';
import { RouterOutlet } from '@angular/router';
import { SideNavComponent } from '../acm/side-nav/side-nav.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-admin-main',
    templateUrl: './admin-main.component.html',
    styleUrls: ['./admin-main.component.scss'],
    imports: [MatSidenavContainer, NgIf, TssComponent, SearchBarComponent, MatButton, SearchResultsComponent, RouterOutlet, MatSidenav_1, SideNavComponent, TranslatePipe]
})
export class AdminMainComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
  * Property to observe the redux auth store
  **/
  @select('auth') readonly authObservable: Observable<Auth>;
  @ViewChild('sidenav', { static: false }) public sidenav: MatSidenav;
  /**
   * @property Property to store the api subscription
   */
  public apiSubscription: Subscription;
  /**
   * @property Property to store the Auth subscription
   */
  public authObservableSubscription: Subscription;
  /**
   *@property apiObservable Property to observe the redux customer store
  **/
  @select('api') readonly apiObservable: Observable<ApiResponseState>;
  /**
   *@property to store if CMS Authorized
  **/
  public isCMSAuthorized: boolean;
  /**
   *@property to store email
  **/
  public email: string;
  /**
   *@property showBanner to store if banner is enabled or not
  **/
  public showBanner = false;
  /**
   *@property banner_message to store the banner message
  **/
  public banner_message: string;
  /**
   *@property showResults flag to show the body of the component
  **/
  public showResults: boolean;
  /**
*@arg selectedVehicleObservable to observe selectedVehicle observable
**/
  @select('selectedVehicle') readonly selectedVehicleObservable: Observable<SelectedVehicleState>;
  /**
 *@property to store the selected vehicle subscriber
 */
  private selectedVehicleSubscriber: Subscription;
  /**
 *@property to store the boolean value to enable/disable the outage banner
 */
  public enableOutageBanner = false;

  constructor(
    private sidenavService: SidenavService,
    private adminDispatcher: AdminDispatcher,
    private authentication: AuthenticationService,
    private orchestrationService: OrchestrationService,
    private fineGrainService: FinegrainRolesService,
    private reduxState: NgRedux<AppState>,
    private authDispatcher: AuthDispatcher
  ) {
    this.apiSubscription = this.apiObservable.subscribe((api) => {
      if (api.apiAction === ApiResponseActions.SET_OUTAGE_BANNER_MESSAGE && api.outageBanner['type'] === 'success') {
        this.showBanner = api.outageBanner['payload'].banner.showBannerAdminPortal;
        this.banner_message = api.outageBanner['payload'].banner.bannerMessage.messageAdminPortalEN;
      }
    });
  }
    /**
  * To route to create CMS ticket
  **/
  public createCMSTicket(): void {
    this.adminDispatcher.setUpdateInfo('cms-ticket', 'cms-ticket', 'cms-ticket', '');
    this.sidenav.toggle();
    window.scrollTo(0, 0);
  }
  /**
  * Property deletmine is admin portal authorized
  **/
  public get isAuthorizedUser(): boolean {
    return this.fineGrainService.getPortalPermissions('admin');
  }

  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
  }
  /**
   * @function ngAfterViewInit Called after the view is initialized
   */
  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }
  /**
   * @function ngOnDestroy Runs final sequence
   */
  ngOnDestroy() {
    this.apiSubscription.unsubscribe();
    if (this.selectedVehicleSubscriber) {
      this.selectedVehicleSubscriber.unsubscribe();
    }

  }
  /**
   * @method toggleSidenav toggles the side nav
   **/
  public toggleSidenav(): void {
    if (this.authentication.isLoggedIn()) {
      this.createCMSTicket();
    }
  }
  /**
   * @method showContent toggle to show results
   **/
  public showContent(show: boolean): void {
    this.showResults = show;
  }
  /**
  * Method getOutageBanner to call getOutageBanner api
  **/
  public getOutageBanner() {
    this.orchestrationService.getOutageBannerMessage();
  }
}
